import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export type Decision = 'ACCEPT' | 'REJECT';

export default function useManageIssuedChangeDecision() {
  const processIssuedPolicyChangeDecision = async (
    manualId: string,
    changeSetId: string,
    decision: Decision,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/policies/v1/manuals/${manualId}/issued-change-sets/${changeSetId}/accept`;

    await fetcher({
      url,
      method: 'POST',
      body: {
        decision,
      },
    })
      .then((data) => {
        if (callback) callback();
      })
      .catch((err) => {
        console.error('Error processing issued change decision', err);
        if (onError) handleError(err, { onError });
      });
  };
  const processIssuedPrefaceChangeDecision = async (
    manualId: string,
    changeSetId: string,
    decision: Decision,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexiverse/prefaces/v1/manuals/${manualId}/issued-change-sets/${changeSetId}/accept`;

    await fetcher({
      url,
      method: 'POST',
      body: {
        decision,
      },
    })
      .then((data) => {
        if (callback) callback();
      })
      .catch((err) => {
        console.error('Error processing issued change decision', err);
        if (onError) handleError(err, { onError });
      });
  };

  return {
    processIssuedPolicyChangeDecision,
    processIssuedPrefaceChangeDecision,
  };
}
